import { SubAPI } from "./SubAPI";

export class Users extends SubAPI {
    ping() {
        return this.fetcher.get<User>("/api/ping");
    }

    setUIFlag(props: { key: string; value: boolean }) {
        return this.fetcher.post<null>("/api/ui-flag", props);
    }

    login(props: { username: string; password: string }) {
        return this.fetcher.postForAuth("/api/auth/login", props);
    }
}

export type User = {
    id: number;
    email: string;
    firstName: string;
    lastName: string;
    role: "admin" | "user";
    confirmedAt: string | null;
    archived: boolean;
    createdAt: string;
    updatedAt: string;

    // masqueradeBy is the admin viewing the app as this user, 0 for a normal session
    masqueradeBy: number;
    masqueradeByName: string;

    // uiFlags names the hints and intro the user has seen (see UIFlagProvider)
    uiFlags: Record<string, boolean>;
}
